import React, { useContext } from 'react';
import styles from './style.css';
import AllocationTable from '../AllocationTable/AllocationTable';
import useCartDetailsState, {
  mapFundLaterFundData
} from '../../hooks/useCartDetailsState';
import PortfolioAllocation from '../PortfolioAllocation/PortfolioAllocation';
import { CartContext } from '../../context/CartContext/CartContext';
import { changeMinimumInvestment } from '../../flows/shared/utils';
import FundLaterFundContents from '../AllocationTable/v2/FundLaterFundContents';

const ReviewPortfolioAllocation = ({
  formattedSelectedFunds,
  small,
  rewardsAvailable = { closedFunds: false, iClassFunds: false },
  amount,
  ugmaFundMinimum = false,
  handleClick = () => {},
  isTaxable = false,
  fundLaterFlow = false
}) => {
  const cartState = useContext(CartContext);
  const { selectedFunds = [], data = {}, totalAmount } = cartState;
  const { mutualFunds: mutualFundsWithAllocations = [] } = data;

  const selectedFundsWithData = mapFundLaterFundData(
    selectedFunds,
    mutualFundsWithAllocations
  );

  // TODO: create an option to retrieve fund minimums
  // by UGMAUTMA account type on the server side
  // so we don't have to mutate data in the UI
  const updatedMutualFundsWithAllocations = changeMinimumInvestment(
    mutualFundsWithAllocations,
    ugmaFundMinimum
  );

  const {
    totalAllocationsValid,
    fundsWithCategories,
    categoryTotals: { overallBonds, overallStocks, overallShortTerm }
  } = useCartDetailsState({
    selectedFunds: formattedSelectedFunds,
    mutualFundsWithAllocations: updatedMutualFundsWithAllocations,
    rewardsAvailable,
    totalAmount
  });

  return (
    <>
      <div className="review-portfolio">
        {fundLaterFlow ? (
          <FundLaterFundContents
            fundsWithCategories={selectedFundsWithData}
            rewardsAvailable={rewardsAvailable}
            amount={amount}
            handleAddMoreFundsClick={handleClick}
            displayAddMore
            readOnly
          />
        ) : (
          <>
            <AllocationTable
              fundsWithCategories={fundsWithCategories}
              shoppingCartEmpty={false}
              rewardsAvailable={rewardsAvailable}
              readOnly
              isTaxable={isTaxable}
              handleAddMoreFundsClick={handleClick}
            />
            {totalAllocationsValid && (
              <PortfolioAllocation
                shoppingCartEmpty={false}
                stocks={overallStocks}
                bonds={overallBonds}
                shortTerm={overallShortTerm}
                small={small}
              />
            )}
          </>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ReviewPortfolioAllocation;
